import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AdminApp from './pages/AdminApp';
import PlayerApp from './pages/PlayerApp';
import PublicScores from './pages/PublicScores';
import './index.css';

const root = document.getElementById('root')!;

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/display" element={<PublicScores />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/*" element={<PlayerApp />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
